import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './Components/Header';
import Sidebar from './Components/SideBar';
import './App.css';

import Home from './Pages/Home';
import CustomerList from './Pages/CustomerList';
import AddCustomer from './Pages/AddCustomer';
import EditCustomer from './Pages/EditCustomer';
import Settings from './Pages/Settings';
import Login from './Pages/Login';
import ViewCustomer from './Pages/ViewCustomer';
import WorkAllotmentView from './Pages/WorkAllotmentView';
import SupplierList from './Pages/SupplierList';
import AddSupplier from './Pages/AddSupplier';
import EditSupplier from './Pages/EditSupplier';
import ViewSupplier from './Pages/ViewSupplier';
import Units from './Pages/Units';
import Brands from './Pages/Brands';
import ProductList from './Pages/ProductList';
import AddProduct from './Pages/AddProduct';
import EditProduct from './Pages/EditProduct';
import PurchaseList from './Pages/PurchaseList';
import AddPurchase from './Pages/AddPurchase';
import EditPurchase from './Pages/EditPurchase';
import ViewPurchase from './Pages/ViewPurchase';
import ProformaList from './Pages/ProformaList';
import AddProforma from './Pages/AddProforma';
import EditProforma from './Pages/EditProforma';
import ViewProforma from './Pages/ViewProforma';
import QuotationList from './Pages/QuotationList';
import AddQuotation from './Pages/AddQuotation';
import EditQuotation from './Pages/EditQuotation';
import ViewQuotation from './Pages/ViewQuotation';
import AddInvoice from './Pages/AddInvoice';
import InvoiceList from './Pages/Invoice';
import EditInvoice from './Pages/EditInvoice';
import ViewInvoice from './Pages/ViewInvoice';
import DeliveryNoteList from './Pages/DeliveryNoteList';
import AddDeliveryNote from './Pages/AddDeliveryNote';
import EditDeliveryNote from './Pages/EditDeliveryNote';
import ViewDeliveryNote from './Pages/ViewDeliveryNote';
import DayBook from './Pages/DayBook';
import StockReport from './Pages/StockReport';
import StockReportWire from './Pages/StockReportWire';
import InHouseStockReport from './Pages/InHouseStockReport';
import PurchaseGSTReport from './Pages/PurchaseGSTReport';
import SalesGST from './Pages/SalesGST';
import CustomerWiseLedger from './Pages/CustomerWiseLedger';
import SalesWiseLedger from './Pages/SalesWiseLedger';
import AddDayBook from './Pages/AddDayBook';
import PurchasePrint from './Pages/PurchasePrint';
import ProformaPrint from './Pages/ProformaPrint';
import CustomerLedgerPrint from './Pages/CustomerLedgerPrint';
import SupplierLedgerPrint from './Pages/SupplierLedgerPrint';
import WorkerLedgerPrint from './Pages/WorkerLedgerPrint';
import InvoicePrint from './Pages/InvoicePrint';
import QuotationPrint from './Pages/QuotationPrint';
import DayBookPrint from './Pages/DayBookPrint';
import StockReportPrint from './Pages/StockReportPrint';
import SalesGSTPrint from './Pages/SalesGSTPrint';
import PurchaseGSTPrint from './Pages/PurchaseGSTPrint';
import DeliveryNotePrint from './Pages/DeliveryNotePrint';
import CustomerOrderHistory from './Pages/CustomerOrderHistory';
import SuppplierOrderHistory from './Pages/SupplierOrderHistory';
import OrderList from './Pages/OrderList';
import AddOrder from './Pages/AddOrder';
import EditOrder from './Pages/EditOrder';
import OrderStatus from './Pages/OrderStatus';
import ViewOrder from './Pages/ViewOrder';
import SupplierWiseLedger from './Pages/SupplierWiseLedger';
import WorkerLedger from './Pages/WorkerLedger';

import AddJobWorker from './Pages/AddJobWorker';
import JobWorkerList from './Pages/JobWorkerList';
import EditJobWorker from './Pages/EditJobWorker';
import ViewJobWorker from './Pages/ViewJobWorker';
import WorkAllotmentList from './Pages/WorkAllotmentList';
import AddWorkAllotment from './Pages/AddWorkAllotment';
import InHouse from './Pages/InHouse';
import AddInHouse from './Pages/AddInHouse';
import WorkAllotmentReturn from './Pages/WorkAllotmentReturn';

import WorkAllotmentReport from './Pages/WorkAllotmentReport';
const MOBILE_BREAKPOINT = 768;

const App = () => {
  // desktop collapsed/open state (controlled by App)
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // mobile overlay open/close state (controlled by App)
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // track whether we are currently on a narrow screen
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  const location = useLocation();

  // on mount and resize, keep App control of default states
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileView(mobile);

      if (mobile) {
        // on mobile keep sidebar closed by default and close any desktop-open state
        setIsSidebarOpen(false);
      } else {
        // on desktop open by default and ensure mobile overlay closed
        setIsSidebarOpen(true);
        setIsMobileOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // toggle called from Header or Sidebar toggle button
  const toggleSidebar = () => {
    if (isMobileView) {
      setIsMobileOpen(prev => !prev);
    } else {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const closeMobileSidebar = () => setIsMobileOpen(false);

  const isLoginPage = location.pathname === '/login';
  if (isLoginPage) return <Login />;


  // Check for print pages to hide sidebar/header
  const isPrintPage = location.pathname.startsWith('/purchaseprint/') ||
    location.pathname.startsWith('/proformaprint/') ||
    location.pathname.startsWith('/invoiceprint/') ||
    location.pathname.startsWith('/customerledgerprint/') ||
    location.pathname.startsWith('/supplierledgerprint/') ||
    location.pathname.startsWith('/workerledgerprint/') ||
    location.pathname.startsWith('/quotationprint/') ||
    location.pathname.startsWith('/daybookprint/') ||
    location.pathname.startsWith('/stockreportprint/') ||
    location.pathname.startsWith('/salesgstprint/') ||
    location.pathname.startsWith('/purchasegstprint/') ||
    location.pathname.startsWith('/deliverynoteprint/');


  // If it's a print page, render only the Routes without any layout wrappers
  if (isPrintPage) {
    return (
      <Routes>
        <Route path="/purchaseprint/:id" element={<PurchasePrint />} />
        <Route path="/proformaprint/:id" element={<ProformaPrint />} />
        <Route path="/invoiceprint/:id" element={<InvoicePrint />} />
        <Route path="/customerledgerprint/:search/:from/:to" element={<CustomerLedgerPrint />} />
        <Route path="/supplierledgerprint/:search/:from/:to" element={<SupplierLedgerPrint />} />
        <Route path="/workerledgerprint/:search/:from/:to" element={<WorkerLedgerPrint />} />
        <Route path="/quotationprint/:id" element={<QuotationPrint />} />
        <Route path="/daybookprint/:id" element={<DayBookPrint />} />
        <Route path="/stockreportprint/:id" element={<StockReportPrint />} />
        <Route path="/SalesGSTPrint/:id" element={<SalesGSTPrint />} />
        <Route path="/purchasegstprint/:id" element={<PurchaseGSTPrint />} />
        <Route path="/deliverynoteprint/:id" element={<DeliveryNotePrint />} />
      </Routes>
    );
  }

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobileView={isMobileView}
        closeMobileSidebar={closeMobileSidebar}
      />

      <main
        className={`main-content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'} ${isMobileOpen ? 'mobile-overlay' : ''}`}
      >
        <div className="outer-container">
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/userlist" element={<CustomerList />} />
            <Route path="/supplierlist" element={<SupplierList />} />
            <Route path="/addcustomer" element={<AddCustomer />} />
            <Route path='/editcustomer/:id' element={<EditCustomer />} />
            <Route path="/viewcustomer/:id" element={<ViewCustomer />} />
            <Route path="/workallotmentview/:id" element={<WorkAllotmentView />} />

            <Route path="/addsupplier" element={<AddSupplier />} />
            <Route path='/editsupplier/:id' element={<EditSupplier />} />
            <Route path="/viewsupplier/:id" element={<ViewSupplier />} />
            <Route path="/units" element={<Units />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/productlist" element={<ProductList />} />
            <Route path="/addproduct" element={<AddProduct />} />
            <Route path="/editproduct/:id" element={<EditProduct />} />
            <Route path="/purchaselist" element={<PurchaseList />} />
            <Route path="/addpurchase" element={<AddPurchase />} />
            <Route path="/editpurchase/:id" element={<EditPurchase />} />
            <Route path="/viewpurchase/:id" element={<ViewPurchase />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/proforma" element={<ProformaList />} />
            <Route path="/addproforma" element={<AddProforma />} />
            <Route path="/editproforma/:id" element={<EditProforma />} />
            <Route path="/viewproforma/:id" element={<ViewProforma />} />
            <Route path="/quotation" element={<QuotationList />} />
            <Route path="/addquotation" element={<AddQuotation />} />
            <Route path="/editquotation/:id" element={<EditQuotation />} />
            <Route path="/viewquotation/:id" element={<ViewQuotation />} />
            <Route path="/invoice" element={<InvoiceList />} />
            <Route path="/addinvoice" element={<AddInvoice />} />
            <Route path="/editinvoice/:id" element={<EditInvoice />} />
            <Route path="/viewinvoice/:id" element={<ViewInvoice />} />
            <Route path="/deliverynote" element={<DeliveryNoteList />} />
            <Route path="/adddeliverynote" element={<AddDeliveryNote />} />
            <Route path="/editdeliverynote/:id" element={<EditDeliveryNote />} />
            <Route path="/viewdeliverynote/:id" element={<ViewDeliveryNote />} />
            <Route path="/daybook" element={<DayBook />} />
            <Route path="/stockreport" element={<StockReport />} />
            <Route path="/stockreportwire" element={<StockReportWire />} />
            <Route path="/inhousestockreport" element={<InHouseStockReport />} />
            <Route path="/purchasegst" element={<PurchaseGSTReport />} />
            <Route path="/salesgst" element={<SalesGST />} />
            <Route path="/customerledger" element={<CustomerWiseLedger />} />
            <Route path="/salesledger" element={<SalesWiseLedger />} />
            <Route path="/adddaybook" element={<AddDayBook />} />
            <Route path="/customerorders/:id" element={<CustomerOrderHistory />} />
            <Route path="/supplierorders/:id" element={<SuppplierOrderHistory />} />
            <Route path="/supplierwiseledger" element={<SupplierWiseLedger />} />
            <Route path="/workerledger" element={<WorkerLedger />} />


            <Route path="/orderlist" element={<OrderList />} />
            <Route path="/addorder" element={<AddOrder />} />
            <Route path="/editorder/:id" element={<EditOrder />} />
            <Route path="/orderstatus" element={<OrderStatus />} />
            <Route path="/vieworder/:id" element={<ViewOrder />} />

            <Route path="/addjobworker" element={<AddJobWorker />} />
            <Route path="/jobworker" element={<JobWorkerList />} />
            <Route path="/editjobworker/:id" element={<EditJobWorker />} />
            <Route path="/viewjobworker/:id" element={<ViewJobWorker />} />

            <Route path="/workallotment" element={<WorkAllotmentList />} />
            <Route path="/addwork" element={<AddWorkAllotment />} />
            <Route path="/inhouse" element={<InHouse />} />
            <Route path="/addinhouse" element={<AddInHouse />} />
            <Route path="/addworkreturn" element={<AddWorkAllotment />} />
            <Route path="/workallotmentreport" element={<WorkAllotmentReport />} />
            <Route path='/workallotmentreturn/:id' element={<WorkAllotmentReturn />} />

            {/* Print Route */}
            <Route path="/purchaseprint/:id" element={<PurchasePrint />} />
            <Route path="/proformaprint/:id" element={<ProformaPrint />} />
            <Route path="/invoiceprint/:id" element={<InvoicePrint />} />
            <Route path="/customerledgerprint/:search/:from/:to" element={<CustomerLedgerPrint />} />
            <Route path="/supplierledgerprint/:search/:from/:to" element={<SupplierLedgerPrint />} />
            <Route path="/workerledgerprint/:search/:from/:to" element={<WorkerLedgerPrint />} />
            <Route path="/quotationprint/:id" element={<QuotationPrint />} />
            <Route path="/daybookprint/:id" element={<DayBookPrint />} />
            <Route path="/stockreportprint/:id" element={<StockReportPrint />} />
            <Route path="/salesgstprint/:id" element={<SalesGSTPrint />} />
            <Route path="/purchasegstprint/:id" element={<PurchaseGSTPrint />} />
            <Route path="/deliverynoteprint/:id" element={<DeliveryNotePrint />} />

            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default App;